







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SingleReport extends Vue {
  @Prop({ type: String, default: null}) code: string
}
